import { render, staticRenderFns } from "./CategoriesHeader.vue?vue&type=template&id=ae603c6c&scoped=true"
import script from "./CategoriesHeader.vue?vue&type=script&lang=ts"
export * from "./CategoriesHeader.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesHeader.vue?vue&type=style&index=0&id=ae603c6c&prod&lang=scss&scoped=true"
import style1 from "./CategoriesHeader.vue?vue&type=style&index=1&id=ae603c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae603c6c",
  null
  
)

export default component.exports